<!-- <li class="panel"> -->
<ng-template [ngIf]="provaScritta">
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(provaScritta)"
				class="btn btn-primary associa" type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-7">{{provaScritta.descrizione}}</h4>
		<p class="col-sm-2">
			Valore: <strong>{{provaScritta.valore | euro}}</strong>
		</p>
		<p class="col-sm-2">
			Scadenza: <strong>{{provaScritta.scadenza |
				date:'dd/MM/yyyy' }}</strong>
		</p>
	</div>
</div>
</ng-template>
<!-- </li> -->
